import { useRef } from 'react';
import cx from 'classnames';

import { CUSTOM_BUTTON_COLOR, CUSTOM_BUTTON_SIZE, CustomButton } from 'src/components/CustomButton';
import { BOOK_DEMO_ORIGIN } from 'src/data/common';
import * as events from 'src/lib/events';
import { useTrackingEvent } from 'src/services';
import { useCustomerMaxMembers } from 'src/store';
import { useInviteUsersPopup } from 'src/views/InviteUsersPopup';
import { useUpgradePopover } from 'src/views/UpgradePopover';

import { useStyles } from './useStyles';

export const InviteUsersButton = ({ className, source, label, upgrade, ...restProps }) => {
  const styles = useStyles();

  const trackingEvent = useTrackingEvent();
  const showInviteUsersPopup = useInviteUsersPopup();
  const buttonRef = useRef();
  const { spendAllInvites } = useCustomerMaxMembers();
  const openUpgradePopover = useUpgradePopover();

  const handleClick = () => {
    if (spendAllInvites) {
      openUpgradePopover({
        referenceElement: buttonRef?.current,
        origin: BOOK_DEMO_ORIGIN.addUser,
      });
      return;
    }

    trackingEvent(events.SETTINGS.clickedInvite, {
      source,
      page: events.EVENT_PAGE.accountSettings,
    });
    showInviteUsersPopup();
  };

  return (
    <CustomButton
      className={cx(styles.root, className)}
      data-testid="inviteUsersButton"
      onClick={handleClick}
      color={CUSTOM_BUTTON_COLOR.silver}
      size={CUSTOM_BUTTON_SIZE.small}
      {...restProps}
      ref={buttonRef}
    >
      {label ? label : 'Invite'}
    </CustomButton>
  );
};
